import React from 'react';
import s from './Footer.module.css';
import phone from '../../img/phone-flat.png';

const Footer = (props) => {
    return (
        <footer className={s.footer}>
                <span className={s.location}>вул. Героїв Небесної Сотні 53, Коростишів, Житомирська область, 12502</span>
                <div className={s.contact_links}>
                    <a href='tel:+380664486238' className={s.contact_item}><img src={phone} alt='phone-icon' ></img></a>
                    <a href='https://www.instagram.com/nishtachok/' className={s.contact_item} target='blank'><img src='https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Instagram_logo_2022.svg/2048px-Instagram_logo_2022.svg.png' alt='instagram-icon'></img></a>
                </div>
                <div className={s.developer}>
                    © 2023 Розробник меню <a href="https://www.instagram.com/v_kat0k/" target='blank'>Влад Катков</a>
                </div>
        </footer>
    )
}

export default Footer;